import React, { useMemo } from 'react';
import classNames from 'classnames';
import * as formatterMap from '../../utils/dataFormatter';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { stringToFunction } from '../../utils/stringToJson';
import moment from 'moment';
import { shallowEqual, useSelector } from 'umi';

type FormatterMapKey = keyof typeof formatterMap;

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  api: string; // api接口
  dataKey?: string; // 数据key
  children: React.ReactNode; // 子元素
  extraParams?: any; // 扩展参数配置
  formatData?: (data: any) => any; // 格式化数据
  formatDataFunc?: FormatterMapKey; // 内建数据格式化的函数方法
  timeZone?: string; // 时区
  data: any;
}

export default function ForecastService(props: IProps) {
  const {
    className,
    style,
    api,
    children,
    dataKey = 'forecastData',
    extraParams,
    formatData: propsFormatData,
    formatDataFunc = "",
    timeZone = "+0",
    data,
    ...restProps
  } = props || {};
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);
  const competitorList = useMemo(() => {
    const list = data?.competitor_list;
    return Array.isArray(list) && list.length > 0 ? list : null;
  }, [data?.competitor_list]);

  // 格式化数据
  const formatData = (data: any) => {
    if (formatDataFunc && formatterMap[formatDataFunc]) {
      return formatterMap[formatDataFunc]?.(data);
    }
    if(typeof propsFormatData === 'function') {
      return propsFormatData?.(data);
    }
    if(typeof propsFormatData === 'string') {
      return stringToFunction?.(data);
    }
    return {
      ...data,
    };
  };

  return (
    <div className={classNames(className)} style={style}>
      <Service
        api={api}
        trackData={["extraParams","competitorList"]}
        data={{ ...props.data, extraParams, competitorList }}
        dataKey={dataKey}
        // 此页面没有筛选器
        filterLoading={false}
        beforeRequest={(data) => {
          const { extraParams, competitorList } = data || {};
          const params = {
            game_code: gameCode,
            date: moment().utcOffset(timeZone).format('YYYY-MM-DD'),
            ...extraParams,
            ...(competitorList? { competitor_list: competitorList } : {}),
          };
          return params;
        }}
        formatData={formatData}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            updatedTime: data?.subtitle,
            ...restProps,
          }),
        )}
      </Service>
    </div>
  );
}